export const dynamicModules = [
	{ 
		module_id: 2610, 
		route: "stellen", 
		apiMapping: "job/offers" 
	},
	{
		module_id: 9999,
		route: "checkout",
		apiMapping: null,
		isStaticPage: true,
	},
	{
		module_id: 1380,
		route: "impressum",
		apiMapping: "organization/legalNotices",
		isStaticPage: true,
	},
	{
		module_id: 1390,
		route: "datenschutz",
		apiMapping: "organization/privacies",
		isStaticPage: true,
	},
	{
		module_id: 4650,
		route: "feedback",
		apiMapping: null,
		isStaticPage: true,
	},
	{ 
		module_id: 9010, 
		route: "formulare", 
		apiMapping: "forms" 
	},
	{ 
		module_id: 1325, 
		route: "links", 
		apiMapping: "organization/urls" 
	},
	// Events
	{ 
		module_id: 1610, 
		route: "veranstaltungen", 
		apiMapping: "events" 
	},
	{ 
		module_id: 4910, 
		route: "agenden", 
		apiMapping: "agendas" 
	},
	{ 
		module_id: 4710, 
		route: "locations", 
		apiMapping: "locations" 
	},
	// Container-Modul
	{ 
		module_id: 100, 
		route: "container", 
		apiMapping: null, 
		isStaticPage: true 
	},
];
